/* eslint-env browser, jquery */
/* global WOW */
import 'bootstrap';
// import debugT from 'debug';
import domify from 'domify';
import Batch from 'batch';
import moment from 'moment';
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import rg from 'modules/npm-component/require-global';
import 'pages/breached-passwords/resources/flipclock.min';
import splash from './breached-passwords-page.pug';
import metadata from './metadata.json';

// const debug = debugT('auth0:breached-passwords');

export default function register() {
  page('/jp/breached-passwords', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const clock = $('.counter').FlipClock(leakedPasswordsCount(), {
    clockFace: 'Counter',
    minimumDigits: `${leakedPasswordsCount()}`.length
  });

  setInterval(() => {
    clock.setTime(leakedPasswordsCount());
  }, 1000);

  window.clock = clock;

  const batch = new Batch();

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    rg(
      '//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js',
      '$.fn.typetype',
      done
    );
  });

  batch.end(next);
}

function leakedPasswordsCount() {
  const initialCount = 1135200000;
  const initialDate = moment(1471013548218);
  const diff = Math.round(moment().diff(initialDate) / 420);

  return initialCount + diff;
}

function snippets(ctx, next) {
  const wow = new WOW();

  wow.init();

  initScrollAnimations();

  playBenefits();

  next();
}

function playBenefits() {
  const $el = $('.js-animate-circles circle');
  const speed = 300;

  function setLoop(counter, duration, backwards) {
    const bounceDuration = duration / 1.2;

    function getCondition() {
      return backwards ? counter >= 0 : counter <= $el.length;
    }

    function removePrev() {
      return backwards
        ? $el.eq(counter + 1).removeAttr('class')
        : $el.eq(counter - 1).removeAttr('class');
    }

    return setInterval(() => {
      if (getCondition()) {
        removePrev();

        $el.eq(counter).css({
          '-webkit-transition-duration': `${bounceDuration}ms`,
          '-moz-transition-duration': `${bounceDuration}ms`,
          'transition-duration': `${bounceDuration}ms`
        });

        $el.eq(counter).attr('class', 'active');

        if (counter === $el.length || counter == 0) {
          const toRemove = counter;

          setTimeout(() => {
            $el.eq(toRemove).removeAttr('class');
          }, duration);
        }

        if (backwards) {
          return (counter -= 1);
        }

        return (counter += 1);
      }
      if (backwards) {
        return (counter = 26);
      }

      return (counter = 27);
    }, duration);
  }

  setLoop(26, speed, true);
  setLoop(12, speed, true);

  setLoop(27, speed);
  setLoop(43, speed);
}

function initScrollAnimations() {
  const newsAnimation1 = new WOW({
    boxClass: 'go-down',
    animateClass: 'move'
  });

  const newsAnimation2 = new WOW({
    boxClass: 'go-up',
    animateClass: 'move'
  });

  const switchAnimation = new WOW({
    boxClass: 'switch-container',
    animateClass: 'enabled'
  });

  // video animation

  $('a.play-me-again').on('click', e => {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  const vid = document.getElementById('breached-video-jp');

  function playVid() {
    vid.play();
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(() => {
      $('a.play-me-again').show();
    }, 9000);
  }

  const lockAnimation = new WOW({
    boxClass: 'example-content',
    mobile: true,
    live: true,
    offset: 200,
    callback(box) {
      playVid();
      showRePlay();
    }
  });

  // end video animation

  newsAnimation1.init();
  newsAnimation2.init();
  switchAnimation.init();
  lockAnimation.init();
}



// WEBPACK FOOTER //
// ./src/pages/jp/breached-passwords/breached-passwords.js